import { Device } from '../interfaces/device';
import { Logical } from '../interfaces/project';
import * as moment from 'moment';

export class ProjectClass {
    id: string;
    name: string;
    protocol: string;
    bodywork: string;
    author: string;
    version: string;
    network: Array<Device>;
    logical: Logical;
    creation_date: string;
    modification_date: string;
    memory_size: number;
    version_project: number;

    constructor({ ProjectID: id, name, protocol, author, version, bodywork }: any) {
        this.id = id;
        this.name = name;
        this.protocol = protocol;
        this.bodywork = bodywork;
        this.author = author;
        this.version = version;
        this.network = [];
        this.logical = {
            blocks: {
                signs: []
            },
            structure: {}
        };
        this.version_project = 1.0
        this.memory_size = 0;
        this.creation_date = moment().format('DD-MM-YYYY hh:mm:ss');
        this.modification_date = moment().format('DD-MM-YYYY hh:mm:ss');
    }
}